import { Component, OnInit } from '@angular/core';
import { LicenceService } from '../licence.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CurrencyService } from '../../../shared/currency.service';
import { AnalyticsService } from 'src/app/shared/analytics/analytics.service';
import { Location } from '@angular/common';
@Component({
  selector: 'app-licence-country-bandgroup',
  templateUrl: './licence-country-bandgroup.component.html',
  styleUrls: ['./licence-country-bandgroup.component.scss']
})
export class LicenceCountryBandgroupComponent implements OnInit {

  licenceCountryBandGroupData : any;
  graphicMode : boolean = false;

  constructor(
    private licenceService: LicenceService,
    private route: ActivatedRoute,
    private router: Router,
    public analyticsService: AnalyticsService,
    public currencyService : CurrencyService,
    private location: Location
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = function() {
      return false;
    };
  }

  ngOnInit() {
    this.route.params.subscribe(p => {
      this.licenceService.getLicencesByCountryBandGroup(p.countryCode, p.bandGroup)
      .subscribe(data => {
        this.licenceCountryBandGroupData=data;
      });
    });
    this.route.fragment.subscribe((fragment: string) => {
      if(fragment && fragment=='graphic'){
        this.graphicMode=true;
      }
    });
  }

  toggleActiveMode() {
    this.analyticsService.pushEvent('toggleGraphicView');
    this.graphicMode=!this.graphicMode;
    if(this.graphicMode){
      this.location.go(this.router.url.split('#')[0] +"#graphic");
    }else{
      this.location.go(this.router.url.split('#')[0]+"#table");
    }
  }

  isGraphicDataAvailable(){
    let fd= this.licenceCountryBandGroupData.frequencyDistributions.frequencyDistributionList;
    return fd
  }

  isGraphicMode() {
    return this.graphicMode;
  }

  isTableMode() {
    return !this.isGraphicMode();
  }

  hideLicensee(row : any): boolean {
    return !row.licensee && !row.licenseeComment;
  }

  hideScope(row : any): boolean {
    return !row.geoScope && !row.geoScopeComment;
  }

  hideMHz(row : any): boolean {
    return !row.bandwidth && !row.mhzFromTo;
  }

  hideAward(row : any): boolean {
    return !row.award || !row.award.type && !row.award.awardKey;
  }

  hideDuration(row : any): boolean {
    return !row.duration && !row.beginDate && !row.beginDateComment && !row.endDate && !row.endDateComment;
  }

  hideLicenceFee(row : any): boolean {
    return !row.fee || (!row.fee.priceEUR && !row.feeComment);
  }

  showAsterisk(operator : any, groupedNames : any): boolean {
    return operator.value == 'Regional licences' && groupedNames;
  }

  isSpectrumLightContent(value: string) {
    if (value === 'BLUR_CONTENT') {
      return '<p class="SpectrumLight">Upgrade...</p>';
    } else {
      return value;
    }
  }

  isSpectrumLightComment(value: string) {
    if (value === 'BLUR_COMMENT') {
      return this;
    }
  }
}
